module.exports = __webpack_public_path__ + "img/banner2.0fe097e6.svg";